export const truncate = (val: string, max: number) => {
  // +2 for the ellipsis
  return val.length <= max + 2 ? val : `${val.substring(0, max)}...`;
};

//get the height of an element based on the text it contains
export function getElementHeightBasedOnString(text: string, elementRef: HTMLElement) {
  const width = elementRef.clientWidth;
  const fontSize = parseInt(getComputedStyle(elementRef).fontSize);
  const tempElement = document.createElement('div');

  tempElement.style.width = width + 'px';
  tempElement.style.fontSize = fontSize + 'px';
  tempElement.style.visibility = 'hidden';
  tempElement.innerText = text;

  document.body.appendChild(tempElement);
  const height = tempElement.clientHeight;
  document.body.removeChild(tempElement);

  return height;
}

export function stripHtmlAndPreserveNewlines(htmlString: string) {
  // Replace specific tags with a newline
  const textWithNewlines = htmlString.replace(
    /<\/p>|<br\s*\/?>|<\/div>|<\/h[1-6]>|<\/li>|<\/blockquote>|<\/form>|<\/tr>/gi,
    '\n'
  );
  // Remove all remaining HTML tags
  const textWithoutHtml = textWithNewlines.replace(/<[^>]*>/g, '');

  return textWithoutHtml;
}

export const getSimpleStringLength = ({ text, charWidth }: { text: string; charWidth: number }) => {
  return text.length * charWidth;
};
